import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll();
  return <section data-section-id="16258" id="pool-deck-contractors-hero" className="relative w-full min-h-[90vh] flex flex-col lg:flex-row overflow-hidden bg-background">
      {}
      <div className="absolute top-[-10%] left-[-10%] w-[40vw] h-[40vw] rounded-full bg-chart-1/5 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-[-10%] right-[40%] w-[30vw] h-[30vw] rounded-full bg-foreground/5 blur-[80px] pointer-events-none" />

      {}
      <div className="w-full lg:w-[55%] flex items-center justify-center px-6 py-16 lg:py-0 relative z-10">
        <div ref={textRef} className={`max-w-2xl w-full transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0 translate-x-0" : "opacity-0 translate-y-10 -translate-x-5"}`}>
          <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold text-foreground leading-[1.1] mb-6 tracking-tight">
            Pool Deck <br />
            <span className="text-chart-1">
              Contractors
            </span>
          </h1>
          <p className="font-default text-lg md:text-xl text-foreground/80 leading-relaxed mb-10 max-w-lg">
            Safety meets sophistication. Since 1990, PCH Builders has crafted 
            luxury pool decks across California that blend architectural beauty 
            with lasting durability.
          </p>

          <div className="flex flex-wrap gap-4">
            <Button asChild className="h-14 px-8 rounded-sm text-lg font-semibold text-white bg-chart-1 hover:bg-chart-1/90 hover:scale-[1.02] transition-all duration-300 shadow-lg border-none">
              <Link to="#">
                Book Free Site Visit
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
            <Button asChild variant="outline" className="h-14 px-8 rounded-sm text-lg font-semibold border-foreground/20 text-foreground hover:bg-foreground/5 hover:text-foreground transition-all duration-300">
              <Link to="#">View Wood Decks</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="w-full lg:w-[45%] relative min-h-[50vh] lg:min-h-auto bg-card/30 lg:bg-transparent">
        <div ref={imageRef} className={`absolute inset-0 flex items-center justify-center p-6 lg:p-12 transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="grid grid-cols-2 gap-4 w-full h-full max-w-lg lg:max-w-none mx-auto content-center">
            {}
            <div className="flex flex-col gap-4 mt-12">
              <div className="relative aspect-[3/4] w-full overflow-hidden rounded-sm shadow-md hover:shadow-xl transition-shadow duration-500 group">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/pool_deck_infinity.png" alt="Stunning infinity pool with wrap-around wood deck" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
              <div className="relative aspect-square w-full overflow-hidden rounded-sm shadow-md hover:shadow-xl transition-shadow duration-500 group">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/pool_deck_wood_detail.png" alt="Close up of premium pool decking materials" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" />
              </div>
            </div>

            {}
            <div className="flex flex-col gap-4 -mt-12">
              <div className="relative aspect-square w-full overflow-hidden rounded-sm shadow-md hover:shadow-xl transition-shadow duration-500 group">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/pool_deck_concrete.png" alt="Modern concrete and structural pool deck design" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="relative aspect-[3/4] w-full overflow-hidden rounded-sm shadow-md hover:shadow-xl transition-shadow duration-500 group">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/pool_deck_california.png" alt="California luxury outdoor living space with pool deck" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}